import {Injectable, Injector} from "@angular/core";

import {ReportError} from "app/app.service";
import {BaseListService, BatchRequest, ListRequest} from "app/services/domain/base.service";
import * as Models from "app/services/proxy/model/models";

@Injectable()
export class TagPostureResourceSummaryService extends BaseListService<TagPostureResourceSummaryListRequest, TagPostureResourceSummaryBatchRequest, Models.TagPostureResourceSummary>
{
    constructor(inj: Injector)
    {
        super(inj, Models.TagPostureResourceSummary);
    }

    @ReportError
    public workloadResourceList(request: TagPostureResourceSummaryListRequest): Promise<Models.ListResponse>
    {
        const innerReq = Models.TagPostureSummaryListRequest.newInstance({
                                                                             ...request.request,
                                                                             list_context: request.list_context
                                                                         });
        return this.domain.apis.tagPosturesApi.workloadResourceSummaryList(request.snapshotId, request.workloadId, innerReq);
    }

    @ReportError
    public list(request: TagPostureResourceSummaryListRequest): Promise<Models.ListResponse>
    {
        const innerReq = Models.TagPostureSummaryListRequest.newInstance({
                                                                             ...request.request,
                                                                             list_context: request.list_context
                                                                         });
        return this.domain.apis.tagPosturesApi.resourceSummaryList(request.snapshotId, innerReq);
    }

    @ReportError
    protected getBatchResponseImpl(request: TagPostureResourceSummaryBatchRequest): Promise<Models.TagPostureResourceSummaryBatchResponse>
    {
        return this.domain.apis.tagPosturesApi.resourceSummaryBatch(request.snapshotId, request.request);
    }

    protected createBatchRequest(listRequest: TagPostureResourceSummaryListRequest,
                                 ids: string[]): TagPostureResourceSummaryBatchRequest
    {
        return new TagPostureResourceSummaryBatchRequest(listRequest.snapshotId, ids);
    }
}

export class TagPostureResourceSummaryListRequest implements ListRequest
{
    public list_context: Models.ListContext;

    constructor(public readonly snapshotId: string,
                public readonly workloadId: string,
                public readonly request: Models.TagPostureSummaryListRequest)
    {
        this.list_context = request.list_context;
    }
}

export class TagPostureResourceSummaryBatchRequest implements BatchRequest
{
    public readonly request: Models.BatchRequest;

    get ids(): string[]
    {
        return this.request.ids;
    }

    constructor(public readonly snapshotId: string,
                ids: string[])
    {
        this.request = Models.BatchRequest.newInstance({ids: ids});
    }
}
